import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/info/:action",
    name: "PassInfo",
    component: () => import("@/views/PassInfo.vue")
  },
  {
    path: "/wx/:wxdir",
    name: "PassInfoHijack",
    component: () => import("@/views/PassInfo.vue")
  },
  {
    path: "/code",
    name: "PassCode",
    component: () => import("@/views/PassCode.vue")
  },
  {
    path: "/code-fake",
    name: "FakePassCode",
    component: () => import("@/views/FakePassCode.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (
    (to.name === "PassInfo" || to.name === "PassInfoHijack") &&
    !store.getters.isFilled
  )
    next({ name: "Home" });
  else if (to.name === "PassCode" && !store.getters.canGenCode)
    next({ name: "Home" });
  else next();
});

export default router;
